module.exports = __webpack_public_path__ + "static/assets/d47ddceea4746a277a587dc45ded2d71.png";